import { render, staticRenderFns } from "./accidentBasicData.vue?vue&type=template&id=7ef7b322&scoped=true&"
import script from "./accidentBasicData.vue?vue&type=script&lang=js&"
export * from "./accidentBasicData.vue?vue&type=script&lang=js&"
import style0 from "./accidentBasicData.vue?vue&type=style&index=0&id=7ef7b322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef7b322",
  null
  
)

export default component.exports